module.exports = __webpack_public_path__ + "img/LamdeiniLearning-136.0de58caf.jpg";